import { DOMAINS } from '../gen/lang.js';
import { PRIVATE_ZOOPLUS_NET } from '../types.js';
import { getCDNBaseUrl } from './serverService.js';

const findDeploymentEnvFromHostName = (hostName) => {
    const WWW_DOMAINS = DOMAINS.map((h) => `www.${h}`);
    if (DOMAINS.includes(hostName) ||
        WWW_DOMAINS.includes(hostName) ||
        hostName.endsWith('k8sp.int.aws.zooplus.io') ||
        (hostName.endsWith(PRIVATE_ZOOPLUS_NET) &&
            !hostName.endsWith(`dev.${PRIVATE_ZOOPLUS_NET}`) &&
            !hostName.endsWith(`release.${PRIVATE_ZOOPLUS_NET}`) &&
            !hostName.endsWith(`beta.${PRIVATE_ZOOPLUS_NET}`))) {
        return 'prod';
    }
    if (hostName.startsWith('test.')) {
        return 'test';
    }
    switch (hostName) {
        case hostName.match(/local/)?.input:
            return 'local';
        case hostName.match(/release/)?.input:
            return 'release';
        case hostName.match(/beta-www/)?.input:
            return 'beta';
        default:
            return 'dev';
    }
};
const findStageFromHostName = (hostName) => {
    const env = findDeploymentEnvFromHostName(hostName);
    return env === 'beta' || env === 'prod' ? 'prod' : 'dev';
};
const findCDNBaseUrlFromHostName = (hostName) => {
    return getCDNBaseUrl(findStageFromHostName(hostName));
};

export { findCDNBaseUrlFromHostName, findDeploymentEnvFromHostName, findStageFromHostName };
//# sourceMappingURL=serverEnvService.js.map
